export const menu = {
  menu_title: 'Resonance',
  menu_logOut: 'Cerrar sesión',
  menu_language_button_text: 'Cambiar',
  menu_languages_modal_title: 'Elige tu idioma',
  menu_questionnaires_modal_title: 'Elige un cuestionario'
};
